import { Typography, Tag } from 'antd';
import { UserAddOutlined } from '@ant-design/icons';
import { useHistory } from 'react-router-dom';
import TimelineEventDot from '../TimelineEventDot';
import TimelineLink from '../TimelineLink';
import { formatDate } from '../../../utils/dateUtils';
import { COLORS, TYPOGRAPHY, SPACING, BORDER_RADIUS } from '../../../constants/theme';

const { Text } = Typography;

const ReferralEvent = ({ referral }) => {
  const history = useHistory();
  const referrerName = `${referral.user?.firstName || ''} ${referral.user?.lastName || ''}`.trim();
  const applicationCount = referral.applications?.length || 0;

  return {
    dot: <TimelineEventDot icon={UserAddOutlined} backgroundColor={COLORS.TIMELINE_REFERRAL} />,
    color: '#434343',
    children: (
      <div style={{ paddingBottom: SPACING.LG, marginLeft: SPACING.SM }}>
        <div style={{ marginBottom: '4px' }}>
          <TimelineLink
            href={`/employees/${referral.user?.id}`}
            onClick={() => history.push(`/employees/${referral.user?.id}`)}
          >
            {referrerName}
          </TimelineLink>
          <Text type="secondary" style={{ fontSize: TYPOGRAPHY.FONT_SIZES.SM, marginLeft: '6px' }}>
            created referral
          </Text>
        </div>
        <div style={{ display: 'flex', alignItems: 'center', gap: SPACING.SM, flexWrap: 'wrap' }}>
          <Text type="secondary" style={{ fontSize: TYPOGRAPHY.FONT_SIZES.SM }}>
            {formatDate(referral.createdAt)}
          </Text>
          {applicationCount > 0 && (
            <Text type="secondary" style={{ fontSize: TYPOGRAPHY.FONT_SIZES.SM }}>
              • {applicationCount} {applicationCount === 1 ? 'app' : 'apps'}
            </Text>
          )}
          {referral.bonusEligible && (
            <Tag
              color="success"
              style={{ margin: 0, fontSize: TYPOGRAPHY.FONT_SIZES.XS, borderRadius: BORDER_RADIUS.SMALL }}
            >
              Bonus Eligible
            </Tag>
          )}
        </div>
      </div>
    ),
  };
};

export default ReferralEvent;
